import React, { useEffect, useState } from "react";
import { fetchAccPlanPositiveNegative } from "../../../services/iqApiV2";
import { useLocation, useParams } from "react-router-dom";
import "./AccountQuarterlyUpdatesV2.css";
import { useUser } from "../../../context/UserContext";
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../services/commonService";

function AccountQuarterlyUpdatesV2() {
  const { clientName, accountName } = useParams();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [showAllHighlights, setShowAllHighlights] = useState("");
  const {user} = useUser()

  const currentUrl = useLocation().pathname;
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await fetchAccPlanPositiveNegative(clientName, accountName);
        setData(resp);
      } catch (err) {
        console.error("Error fetching positive/negative plan:", err);
      } finally {
        setLoading(false);
      }
    };
    if(user?.id){
      setTimeout(() => {
        fetchData();
      }, [100])
    }
  }, [user?.id]);

  const MAX_VISIBLE = 5;
  const positives = data?.top_positives || [];
  const negatives = data?.top_concerns || [];

  const shouldShowToggle = positives.length > MAX_VISIBLE || negatives.length > MAX_VISIBLE;


  useEffect(() => {
    if(user?.id && (showAllHighlights === false || showAllHighlights === true)){
      console.log("showAllHighlights : ", showAllHighlights)
      const msg = showAllHighlights ? 'Expanded' : 'Collapsed'

      let userStat = getUserStatsObject(
        'Overview',
        "recent_highlights",
        "Page Source: Recent Highlights - "+msg,
        currentUrl,
        ''
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
    
  }, [user?.id, showAllHighlights])

  if(!positives?.length){
    return <></>
  }

  return (
    <div className="qauter_wrapper p-4">
      <div className="highlights_header">
        <h5 className="highlights_title">Recent Highlights: Positives & Potential Concerns</h5>
      </div>
<div
  className={`highlights_expandable_wrapper ${showAllHighlights ? "expanded" : ""}`}
>
      <div className="highlights_content">
        <div className="col-md-6 highlights_section highlights_positive">
          <div className="highlights_label">
            <span className="highlights_content_dot highlights_content_green"></span>
            <span className="positive_head_plan">Positives</span>
          </div>
          {loading ? (
            <ul className="highlights_list_bullets">
              {Array.from({ length: 4 }).map((_, i) => (
                <li key={i} className="HIGHLIGHT_ACC_skeleton HIGHLIGHT_ACC_skeleton_title" />
              ))}
            </ul>
          ) : (
            <ul className="highlights_list_bullets">
              {(showAllHighlights ? positives : positives.slice(0, MAX_VISIBLE)).map((item, index) => (
                <li key={`positive_${index}`}>{item}</li>
              ))}
            </ul>
          )}
        </div>

        <div className="col-md-6 highlights_section highlights_negative">
          <div className="highlights_label">
            <span className="highlights_content_dot highlights_content_red"></span>
            <span className="negative_head_plan">Potential Concerns</span>
          </div>
          {loading ? (
            <ul className="highlights_list_bullets">
              {Array.from({ length: 4 }).map((_, i) => (
                <li key={i} className="HIGHLIGHT_ACC_skeleton HIGHLIGHT_ACC_skeleton_title" />
              ))}
            </ul>
          ) : (
            <ul className="highlights_list_bullets">
              {(showAllHighlights ? negatives : negatives.slice(0, MAX_VISIBLE)).map((item, index) => (
                <li key={`negative_${index}`}>
                  {item}</li>
                
              ))}
            </ul>
          )}
        </div>
      </div>

     
</div>
 {shouldShowToggle && (
        <div className="highlights_toggle_button_container">
          <button
            className={`view_more_btn_text ${showAllHighlights ? "expanded" : ""}`}
            onClick={() => setShowAllHighlights((prev) => !prev)}
          >
            {showAllHighlights ? "View Less" : "View More"}
            <svg
              className="arrow_svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 9L12 15L18 9"
                stroke="#007bff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}

export default AccountQuarterlyUpdatesV2;
